import React from 'react'

function AboutOne({ className }) {
    return (
        <>
            {/* About area Start */}
            <section id="about" className={`rts-about-area ${className}`}>
                <div className="container">
                    <div className="section-inner">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-4">
                                <div className="image-area">
                                    <img
                                        className="wow scaleIn"
                                        data-wow-delay=".8s"
                                        data-wow-duration="1s"
                                        src="assets/images/about/about-01.svg"
                                        alt=""
                                    />
                                    <img
                                        className="float-img wow fadeIn"
                                        data-wow-delay="1s"
                                        data-wow-duration="2s"
                                        src="assets/images/about/leaf-01.svg"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-8">
                                <div className="about-content-wrapper">
                                    <div className="section-title-area">
                                        <p
                                            className="sub-title wow fadeInUp"
                                            data-wow-delay=".2s"
                                            data-wow-duration="2s"
                                        >
                                            About Memo Coin
                                        </p>
                                        <h2
                                            className="section-title wow fadeInUp"
                                            data-wow-delay=".5s"
                                            data-wow-duration="2s"
                                        >
                                            Empowering Creativity One Coin at a Time
                                        </h2>
                                    </div>
                                    <p
                                        className="desc mb--20 wow fadeInUp"
                                        data-wow-delay=".8s"
                                        data-wow-duration="2s"
                                    >
                                        Our Meme Coin isn’t just a cryptocurrency; it’s a movement
                                        powered by creativity, community, and a love for laughter.
                                        Designed to bring humor to the blockchain world, Meme Coin
                                        bridges the gap between entertainment and innovative digital
                                        assets.
                                    </p>
                                    <p
                                        className="desc wow fadeInUp"
                                        data-wow-delay="1.1s"
                                        data-wow-duration="2s"
                                    >
                                        With Meme Coin, you can trade, share, and even support your
                                        favorite meme creators while becoming part of a global network
                                        of enthusiasts.
                                    </p>
                                    <div
                                        className="button-area wow fadeInUp"
                                        data-wow-delay="1.4s"
                                        data-wow-duration="2s"
                                    >
                                        <div className="button with-after2">
                                            <a href="#" className="rts-btn btn-primary">
                                                Read More
                                            </a>
                                        </div>
                                    </div>
                                    <img
                                        className="shape wow fadeIn"
                                        data-wow-delay="1.4s"
                                        data-wow-duration="2s"
                                        src="assets/images/about/coin-big.svg"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="float-img2">
                            <img src="assets/images/about/leaf-02.svg" alt="" />
                            <img src="assets/images/about/leaf-03.svg" alt="" />
                        </div>
                    </div>
                </div>
            </section>
            {/* About area end */}
        </>
    )
}

export default AboutOne